import { Component, OnInit, inject } from '@angular/core';
import { catchError, mergeMap, of } from 'rxjs';
import { DynamicBasePageComponent } from '../../formly/dynamic-base-page/dynamic-base-page.component';
import { AppConfig } from '../../formly/model/AppConfig';
import { DataEventService } from '../../../utils/data-event.service';

@Component({
  selector: 'app-fnol-upload',
  templateUrl: './fnol-upload.component.html',
  styleUrls: ['./fnol-upload.component.scss']
})
export class FnolUploadComponent extends DynamicBasePageComponent implements OnInit {

  private eventService = inject(DataEventService);

  // Standalone Dynamic UI app. Load the app config, then check whether files were already
  // uploaded for this externalId. Option B: if so, show the confirmation (done) page and block
  // re-upload; otherwise show the upload page. externalId is placed in claimContext by the app
  // bootstrap.
  override ngOnInit(): void {
    const externalId = this.context.claimContext['externalId'];

    this.dynamicService.getAppConfig('fnol_upload_1.0').pipe(
      mergeMap((appConfig: AppConfig) => {
        this.dynamicContext.appConfig = appConfig;
        return this.dynamicService.getStoredData(appConfig, { externalId });
      }),
      catchError(() => of({}))
    ).subscribe((storedData: any) => {
      // The app root skips the efnol_2.0 bootstrap for this standalone route, so emit the header
      // event here (async, after the header has subscribed) to render the branded header.
      this.eventService.sendData({ efnolLogoSrcNm: 'PR_logo.svg' }, 'app-initialized');

      if (this.hasUploadedFiles(storedData)) {
        // Already uploaded: show the confirmation (done) page, no uploader.
        this.context.claimContext = { ...(storedData || {}), externalId };
        this.routePath = this.router.url.replace(/\//g, '');
        this.jsonData = this.context.claimContext;
        this.retrievePageConfig({ destinationPageKey: 'fnol_upload_confirmation' }).subscribe();
      } else {
        // No prior upload: render the upload page.
        super.ngOnInit();
      }
    });
  }

  // True when saved data for this externalId already contains at least one uploaded file.
  private hasUploadedFiles(data: any): boolean {
    if (!data || typeof data !== 'object') { return false; }
    const page = data['fnol_upload'] ?? data;
    const files = page?.['fileUpload'];
    return Array.isArray(files) && files.length > 0;
  }

}
